var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPages)?_c('div',{staticClass:"text-center pt-2"},[_c('v-pagination',{attrs:{"total-visible":9,"value":_vm.data.current_page,"length":_vm.data.last_page},on:{"input":function($event){return _vm.$emit('click', $event)}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }